import * as actionTypes from "../actions/actionTypes";

export const saveFavoriteRims = favRims => {
        return {
            type: actionTypes.SAVE_FAVRIMS,
            favRims
        };
};
